import {Http} from './http.init'
import {ErrorWrapper, ResponseWrapper} from './util'
import _ from "lodash";

// let GRM_AUTH_TOKEN = ''
let GRM_ROOM_AUTH_TOKEN = ''

const Token = {
    accessToken: {
        token: ''
    },
    refreshToken: {
        token: ''
    },
    roomToken: {
        token: ''
    }
};
const GRMKEY_SESSION_AUTH_TOKEN = 'GRMKEY_SESSION_AUTH_TOKEN';
const GRMKEY_SESSION_AUTH_REFRESH_TOKEN = 'GRMKEY_SESSION_AUTH_REFRESH_TOKEN';

export class AuthService {

    static async makeLogin ({ email, password }) {
        try {
            const response = await Http.getHttpInstance({auth: false}).post(`/api/v3/auth/token`,
                { email, password, isAdmin:false })
            _setAuthData({
                accessToken: response.data.data.accessToken,
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    static async guestLogin (nickname) {
        try {
            const response = await Http.getHttpInstance({auth: false}).post(`/api/v3/auth/guest-token`, {nickname, isGuest : true})
            _setAuthData({
                accessToken: response.data.data.accessToken,
                refreshToken: response.data.data.refreshToken,
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    static async mobileTokenLogin(token) {
        try {
            const response = await Http.getHttpInstance({auth: false}).post(`/api/v3/auth/mobile`, {token : token})
            _setAuthData({
                accessToken: response.data.data.accessToken,
                refreshToken: response.data.data.refreshToken
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    static async currentUser () {
        try {
            const response = await Http.getHttpInstance({auth: true}).get(`/api/v3/auth/current`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    static async requestEnter (roomId, params={}) {
        try {
            // const response = await new Http({auth: true}).post(`/api/v3/lecture/${roomId}/reqEnter`, params)
            const response = await Http.getHttpInstance({auth: true}).post(`/api/v3/room/${roomId}/reqEnter`, params)
            _setRoomAuthData({
                accessToken: response.data.data.roomToken.accessToken,
                // exp: parseTokenData.exp
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    static async refreshTokens () {
        try {
            const response = await Http.getHttpInstance({auth: false})
                .post(
                    `/api/v3/auth/refresh-tokens`,
                    {},
                    {
                        headers: {
                            'GRM-ROOM-AUTH-TOKEN': this.getRefreshToken()
                        }
                    }
                )
            _setAuthData({
                accessToken: response.data.data.accessToken,
                exp: _parseTokenData(response.data.data.accessToken).exp
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            _resetAuthData()
            // alert('로그인 후 사용가능합니다.')
            // window.close();
            throw new ErrorWrapper(error)
        }
    }

    static async deleteToken() {
        try {
            const response = await Http.getHttpInstance({auth: false}).delete(`/api/v3/auth/token`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    // static setRefreshToken (status) {
    //     if (!['', 'true'].includes(status)) {
    //         throw new Error(`setRefreshToken: invalid value ${status}; Expect one of ['', 'true']`)
    //     }
    //
    //     localStorage.setItem('refreshToken', status)
    // }

    static debounceRefreshTokens = this._debounce(() => {
        return this.refreshTokens()
    }, 100)

    static getAuthToken () {
        let authToken = Token.accessToken.token;
        if(!authToken){
            authToken = Token.accessToken.token = sessionStorage.getItem(GRMKEY_SESSION_AUTH_TOKEN);
        }
        return authToken
    }

    static getRefreshToken () {
        const token = sessionStorage.getItem(GRMKEY_SESSION_AUTH_REFRESH_TOKEN);
        return token
    }

    static getRoomAuthToken () {
        return GRM_ROOM_AUTH_TOKEN
    }

    static getAuthData () {
        const data = Token.accessToken.data;
        if(!data) return null;
        return _.cloneDeep(data);
    }

    static setAuthToken (accessToken) {
        if(accessToken === null){
            Token.accessToken.token = null;
            sessionStorage.removeItem(GRMKEY_SESSION_AUTH_TOKEN);
            return;
        }
        Token.accessToken.token = accessToken
        Token.accessToken.data = _parseTokenData(accessToken);
        sessionStorage.setItem(GRMKEY_SESSION_AUTH_TOKEN, accessToken);
    }

    static setRoomAuthToken (accessToken) {
        GRM_ROOM_AUTH_TOKEN = `${accessToken}`
    }

    static _debounce (inner, ms = 0) {
        let timer = null
        let resolves = []

        return function () {
            clearTimeout(timer)
            timer = setTimeout(() => {
                const result = inner()
                resolves.forEach(r => r(result))
                resolves = []
            }, ms)

            return new Promise(resolve => resolves.push(resolve))
        }
    }

    static isAccessTokenExpired () {
        const accessToken = this.getAuthToken();
        if(!accessToken){
            return true;
        }

        if(!Token.accessToken.data){
            Token.accessToken.data = _parseTokenData(accessToken);
        }

        const accessTokenExpDate = Token.accessToken.data.exp - 10
        const nowTime = Math.floor(new Date().getTime() / 1000)
        return accessTokenExpDate <= nowTime
    }

    // static hasRefreshToken () {
    //     return Boolean(localStorage.getItem('refreshToken'))
    // }
}

function _resetAuthData () {
    // reset tokens
    // AuthService.setRefreshToken('')
    AuthService.setRoomAuthToken('')
}

function _setAuthData ({ accessToken } = {}) {
    AuthService.setAuthToken(accessToken);
    // AuthService.setRefreshToken('true')
}

function _setRoomAuthData ({ accessToken } = {}) {
    AuthService.setRoomAuthToken(accessToken)
}

function _parseTokenData (accessToken) {
    let payload = ''
    let tokenData = {}
    try {
        payload = accessToken.split('.')[1]
        tokenData = JSON.parse(decodeURIComponent(escape(window.atob((payload).replace(/-/g, "+").replace(/_/g, "/")))))
    } catch (error) {
        throw new Error(error)
    }
    return tokenData
}

window && window.addEventListener('close', e => {
    _setAuthData({accessToken: null})
})